export default "__VITE_ASSET__pitzYwHd__"